import React, {useMemo} from 'react';
import {Redirect, Route, Switch} from 'react-router-dom';
import {mainPath} from '../../../routes/paths';
import UserDetails from '../UserDetails';
import UserNotification from '../UserNotification';
import UserSettings from '../UserSettings';
import Menu from '../../Components/Menu';
import {ReactComponent as ProfileIcon1} from '../../../assets/images/profile/Menu/project1.svg';
import {ReactComponent as ProfileIcon2} from '../../../assets/images/profile/Menu/project2.svg';
import {ReactComponent as ProfileIcon3} from '../../../assets/images/profile/Menu/project3.svg';
import {ReactComponent as ProfileIcon5} from '../../../assets/icons/dictionary.svg';
import {ReactComponent as ProfileIcon4} from '../../../assets/icons/load.svg';
import {useTranslation} from 'react-i18next';
import UserDictionaries from '../UserDictionaries';
import {useSelector} from 'react-redux';
import {hasPermission} from '../../../helpers/functions';
import {PERMISSIONS} from '../../../helpers/constants';

const ProfileInner = ({toggleYourContent, handleNavLinkClick, isInnerVisible, isMenuVisible}) => {
    const {t} = useTranslation();
    const {profileMe} = useSelector((state) => state.profile);

    const permissionCreate = hasPermission(PERMISSIONS.LOCATION_CREATE, profileMe?.permissions ?? []);
    const isFinancier = profileMe?.role === 'financier';
    const menuList = useMemo(() => {
        const list = [
            {name: t('profile.personalInfo'), icon: <ProfileIcon1/>, link: mainPath.userDetails},
            {name: t('profile.notifications'), icon: <ProfileIcon2/>, link: mainPath.userNotification},
            {name: t('profile.settings'), icon: <ProfileIcon3/>, link: mainPath.userSettings}
        ];

        if (permissionCreate) {
            list.push({name: t('profile.catalog'), icon: <ProfileIcon5/>, link: mainPath.userDictionary});
        }

        return list;
    }, [t, permissionCreate]);

    return (
        <>
            {isMenuVisible && (
                <Menu
                    title={t('profile.yourProfile')}
                    menuList={menuList}
                    toggleYourContent={toggleYourContent}
                    handleNavLinkClick={handleNavLinkClick}
                    additionalMenuItems={
                        <>
                            <div
                                className='items'
                                onClick={() => {
                                    window.location.reload();
                                }}
                            >
                                <div className='items__blocks'>
                                    <ProfileIcon4/>
                                    <div className='items__name'>{t('ProjectsInner.clear')}</div>
                                </div>
                            </div>
                        </>
                    }
                />
            )}
            {isInnerVisible && (
                <Switch>
                    <Redirect from={mainPath.profile} exact to={mainPath.userDetails}/>
                    <Route path={mainPath.userDetails} component={UserDetails}/>
                    {!isFinancier ? <Route path={mainPath.userNotification} component={UserNotification}/> : null}
                    <Route path={mainPath.userSettings} component={UserSettings}/>
                    <Route path={mainPath.userDictionary} component={UserDictionaries}/>
                </Switch>
            )}
        </>
    );
};

export default ProfileInner;
